import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero.jsx';
import { FadeUp } from '../components/Motion.jsx';

const EMA_URL = 'https://www.ema.europa.eu/en/medicines/human/EPAR/foscan#product-information';

const groups = [
  {
    title: 'Science & treatment',
     links: [
    { label: 'Foscan®', to: '/foscan', desc: 'Product information links' },
    { label: 'Photodynamic therapy', to: '/pdt', desc: 'How the treatment works' },
    { label: 'Head & neck cancer', to: '/head-neck-cancer', desc: 'Clinical background' },
  ],
  },
  {
    title: 'Company',
    links: [
      { label: 'Home', to: '/', desc: 'Homepage' },
      { label: 'About biolitec Pharma', to: '/about', desc: 'Company and group overview' },
      { label: 'Contact', to: '/contact', desc: 'Offices and enquiries' },
    ],
  },
  {
    title: 'Compliance',
    links: [
      { label: 'Adverse event report', to: '/adverse-event-report', desc: 'Report an adverse event' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Imprint', to: '/imprint', desc: 'Company legal details' },
      { label: 'Privacy policy', to: '/privacy-policy', desc: 'How we handle personal data' },
    ],
  },
];

export default function Sitemap() {
  return (
    <>
      <PageHero
        eyebrow="NAVIGATION"
        title="Sitemap"
        subtitle="An overview of every page on this website."
      />

      <div className="page-shell">
        <div className="sitemap-grid">
          {groups.map((group, i) => (
            <FadeUp key={group.title} delay={i * 0.08}>
              <section className="sitemap-group">
                <h2 className="sitemap-group-title">{group.title}</h2>
                <ul className="sitemap-links">
                  {group.links.map((l) => (
                    <li key={l.to}>
                      <Link to={l.to} className="sitemap-link">
                        <span>
                          <span className="sitemap-link-label">{l.label}</span>
                          <span className="sitemap-link-desc">{l.desc}</span>
                        </span>
                        <span className="sitemap-link-arrow" aria-hidden="true">→</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </section>
            </FadeUp>
          ))}
        </div>

        <FadeUp>
          <div className="inline-note">
            <p>
              For regulatory product information, see the{' '}
              <a href={EMA_URL} target="_blank" rel="noopener noreferrer">
                European Medicines Agency (EMA)
              </a>.
            </p>
          </div>
        </FadeUp>
      </div>
    </>
  );
}